export const getSettings = async ({
  store,
  key,
  setValue = (res) => {},
}: {
  store: any;
  key: string;
  setValue?: (e) => void;
}) => {
  const res = await store?.get(key);
  setValue(res);
  return res;
};
export const updateSettings = async ({
  store,
  key,
  value,
  setValue = (res) => {},
}) => {
  const res = await store?.set(key, value);
  setValue(res);
  return value;
};
export const resetDefaultSettings = async ({
  store,
  key,
  defaultSettings,
  setValue = (res) => {},
}) => {
  await store?.set(key, defaultSettings);
  const res = await getSettings({ store, key, setValue });
  setValue(res);
  return res;
};
